import { path } from 'ramda'

/**
 * Format phone input as xxx-xxx-xxxx while typing
 * Removes non-digits, groups by 3-3-4, joins with dashes
 */
export const formatPhoneInput = (value) => {
  const digitsOnly = value.replace(/[^0-9]/g, '')
  const parts = []

  if (digitsOnly.length > 0) {
    parts.push(digitsOnly.substring(0, 3))
  }
  if (digitsOnly.length > 3) {
    parts.push(digitsOnly.substring(3, 6))
  }
  if (digitsOnly.length > 6) {
    parts.push(digitsOnly.substring(6, 10))
  }

  return parts.join('-')
}

/**
 * Format verification code input (4 digits max)
 */
export const formatCodeInput = (value) => {
  return value.replace(/[^0-9]/g, '').substring(0, 4)
}

/**
 * Check if phone is set but awaiting verification
 */
export const isPhoneAwaitingVerification = (user) => {
  return path(['info', 'phone'], user) && path(['info', 'phoneConfirmKey'], user)
}

/**
 * Check if phone is fully verified
 */
export const isPhoneFullyVerified = (user) => {
  return path(['info', 'phone'], user) && !path(['info', 'phoneConfirmKey'], user)
}
